import { createJSONRequest } from './create-request'

export const getKeywordsForValue = (value, type = '', productKeywords = false) => createJSONRequest({
  url: `/api/keywords?value=${encodeURIComponent(value)}&type=${type}&productKeywords=${productKeywords}`,
  method: 'GET',
})
